import React, { useState } from 'react';
import { Button, ButtonGroup, Callout } from 'ui';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import supportsLocalStorage from 'utils/supportsLocalStorage';
import LinkButton from 'components/shared/LinkButton';
import trackEvent from 'misc/trackEvent';

const CertificationBanner = () => {
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const [interestedClicked, setInterestedClicked] = useState(
    !!localStorage.getItem('certification_banner_clicked'),
  );
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const interestedButtonClicked = () => {
    trackEvent('assess/certification_banner_clicked', { button: 'interested' });
    if (supportsLocalStorage) {
      localStorage.setItem('certification_banner_clicked', true);
    }
    setInterestedClicked(true);
    setShowSuccessMessage(true);

    setTimeout(() => setShowSuccessMessage(false), 3000);
  };

  const dismissBanner = () => {
    trackEvent('assess/certification_banner_clicked', { button: 'dismiss' });
    request
      .post(routes.TUTORIAL.DISMISS, { tutorial: 'certification_banner' })
      .then(response => {
        setBannerDismissed(true);
      });
  };

  const successMessage = (
    <div className="NotificationContainer NotificationContainer--success bdrs-2 mb-16 d-f ai-c jc-sb">
      <span>{t('demonstrations.product_lead_growth.success_message')}</span>
    </div>
  );

  const actions = (
    <div className="d-f ai-c jc-sb m-fd-c m-ai-fs">
      <ButtonGroup>
        <Button
          rel="noopener noreferrer"
          target="_blank"
          url="https://intercom.help/lessonly/en/articles/3816672"
          onClick={() => {
            trackEvent('assess/certification_banner_clicked', {
              button: 'learn_more',
            });
          }}
        >
          {t('practice.on_demand_practice.clarity.learn_more')}
        </Button>
        <Button
          customColor
          onClick={interestedButtonClicked}
          disabled={interestedClicked}
        >
          {interestedClicked
            ? t('demonstrations.product_lead_growth.submitted')
            : t('demonstrations.product_lead_growth.interested')}
        </Button>
      </ButtonGroup>
      <LinkButton onClick={dismissBanner}>
        {t('practice.on_demand_practice.clarity.got_it')}
      </LinkButton>
    </div>
  );

  return !bannerDismissed ? (
    <>
      {showSuccessMessage && successMessage}
      <Callout
        actions={actions}
        title={t('demonstrations.product_lead_growth.title')}
        className="mb-16 mt-16"
        icon="interestshield"
        iconClass="fz-64"
      >
        <div>{t('demonstrations.product_lead_growth.text_1')}</div>
        <div>{t('demonstrations.product_lead_growth.text_2')}</div>
      </Callout>
    </>
  ) : null;
};

export default CertificationBanner;
